var map = {
	"./appstore.svg": 99548,
	"./background/mineirao.png": 92704,
	"./background/video.jpg": 41479,
	"./googleplay.svg": 27103,
	"./icon-alert.svg": 84342,
	"./icon-mais.svg": 79686,
	"./icon-menos.svg": 47634,
	"./icon-success.svg": 27941,
	"./icons-outline.svg": 34883,
	"./icons.svg": 70714,
	"./icons/voltar.svg": 12833,
	"./loading-icon.svg": 34246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36240;